<script>
    import {onMount, onDestroy, createEventDispatcher} from 'svelte';

    export let sitekey = '';
    export let token = '';

    const dispatch = createEventDispatcher();

    const callbackName = `__reviewCaptchaCallback_${Math.random().toString(36).slice(2)}`;
    const SCRIPT_SRC = 'https://smartcaptcha.yandexcloud.net/captcha.js';

    let host;
    let widgetId = null;

    function renderWidget() {
        if (!host || widgetId !== null || !window.smartCaptcha) return;
        widgetId = window.smartCaptcha.render(host, {
            sitekey,
            callback: (newToken) => {
                token = newToken || '';
                dispatch('token', token);
            },
        });
    }

    function waitForApi() {
        if (window.smartCaptcha) {
            renderWidget();
            return;
        }
        const start = Date.now();
        const timer = setInterval(() => {
            if (window.smartCaptcha) {
                clearInterval(timer);
                renderWidget();
            } else if (Date.now() - start > 10000) {
                clearInterval(timer);
            }
        }, 100);
    }

    onMount(() => {
        if (!sitekey) return;

        const existingScript = document.querySelector(`script[src*="smartcaptcha.yandexcloud.net/captcha.js"]`);
        if (existingScript) {
            waitForApi();
        } else {
            const script = document.createElement('script');
            script.src = SCRIPT_SRC;
            script.async = true;
            script.defer = true;
            script.addEventListener('load', waitForApi);
            document.head.appendChild(script);
        }
    });

    onDestroy(() => {
        if (widgetId !== null && window.smartCaptcha) {
            try {
                window.smartCaptcha.destroy(widgetId);
            } catch (_) {}
            widgetId = null;
        }
    });
</script>

{#if sitekey}
    <div class="captcha-host" bind:this={host}></div>
{:else}
    <div class="captcha-warning">Капча не настроена</div>
{/if}

<style>
    .captcha-host {
        display: block;
    }

    .captcha-warning {
        padding: 8px 12px;
        background: #fff4e5;
        border: 1px solid #f0c08a;
        border-radius: 6px;
        color: #8a5a1a;
        font-size: 13px;
    }
</style>
